import React, { useEffect, useState } from "react";
import { FaRegCircleUser, FaPenToSquare, FaCheck, FaX } from "react-icons/fa6";
import { toast } from "react-toastify";
import "../../pages/user/css/Curriculum.css";
import { API_ciudadanos } from "../../config/apiConfig";
import { useAuth } from "../../context/AuthContext";

const SobreMi = ({ usuario }) => {
  const { token } = useAuth();

  // Estado para almacenar el texto "Sobre mí"
  const [texto, setTexto] = useState("");
  const textoPorDefecto =
    "Escribe aquí un texto que pueda ser interesante para las ofertas de empleo.";

  // Estados de edición
  const [editando, setEditando] = useState(false);
  const [tempTexto, setTempTexto] = useState(texto);

  useEffect(() => {
    if (usuario?.sobreMi && usuario.sobreMi.trim() !== "") {
      setTexto(usuario.sobreMi);
      setTempTexto(usuario.sobreMi);
    } else {
      // Si no hay info, usar texto por defecto
      setTexto(textoPorDefecto);
      setTempTexto(textoPorDefecto);
    }
  }, [usuario]);

  // Guardar cambios
  const handleSave = async () => {
    try {
      const res = await fetch(`${API_ciudadanos}/${usuario.userId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": token,
        },
        body: JSON.stringify({ sobreMi: tempTexto }),
      });

      if (!res.ok) throw new Error("Error al actualizar el texto");

      setTexto(tempTexto);
      setEditando(false);
      toast.success("Texto 'Sobre mí' actualizado correctamente");
    } catch (error) {
      console.error("❌ Error al actualizar 'Sobre mí':", error);
      toast.error("Error al guardar el texto");
    }
  };

  // Cancelar edición
  const handleCancel = () => {
    setTempTexto(texto); // Restaurar el texto original
    setEditando(false);
  };

  return (
    <div className="ocupaciones caja-verde">
      {/* Título con icono de edición alineado a la derecha */}
      <div className="titulo-editar between fondo-verde">
        <h2 className="blanco fondo-verde align-center mayusculas">
          <FaRegCircleUser /> SOBRE MÍ
        </h2>
        {!editando && (
          <button
            aria-label="Editar texto"
            className="fondo-verde no-border blanco"
            onClick={() => setEditando(true)}
          >
            <FaPenToSquare />
          </button>
        )}
      </div>

      <div className="contenido">
        {editando ? (
          <>
            <textarea
              className="editar-texto w-100"
              value={tempTexto}
              onChange={(e) => setTempTexto(e.target.value)}
              aria-label="Texto Sobre mí"
            />

            {/* Botones Guardar o cancelar edición */}
            <div className="check flex gap-10">
              <button
                aria-label="Guardar cambios"
                className="fondo-blanco verde"
                onClick={handleSave}
              >
                <FaCheck />
              </button>
              <button
                aria-label="Cancelar cambios"
                className="fondo-blanco rojo"
                onClick={handleCancel}
              >
                <FaX />
              </button>
            </div>
          </>
        ) : (
          <p className={texto === textoPorDefecto ? "texto-defecto" : ""}>
            {texto}
          </p>
        )}
      </div>
    </div>
  );
};

export default SobreMi;
